var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"nonzero","d":"M8.88 8l6.94-6.93a.62.62 0 10-.89-.89L8 7.12 1.07.18a.62.62 0 10-.89.89L7.12 8 .18 14.93a.62.62 0 10.89.89L8 8.88l6.93 6.94a.62.62 0 00.89 0 .62.62 0 000-.89L8.88 8z"}));
}

Close.defaultProps = {"width":"16","height":"16","fill":"#494848","viewBox":"0 0 16 16"};

module.exports = Close;

Close.default = Close;
